import React from 'react'
import { Link } from 'react-router-dom'

const SupplierDashboard = () => {

  // Test Data
  const listings = [
    { 
      id: 1,
      image: "/assets/images/skincare-cream-jar.png",
      
      name: "Product 1",
      price: "$120.25",
      shipping: "Free Shipping",
      uptime: "15"
    },

    { 
      id: 2,
      image: "/assets/images/serum-bottle.jpg",
      
      name: "Product 2",
      price: "$126.25",
      shipping: "$4.25 Shipping",
      uptime: "15"
    },

    { 
      id: 3,
      image: "/assets/images/pink-skincare-product.jpg",
      
      name: "Product 3",
      price: "$1,220.25",
      shipping: "Free",
      uptime: "15"
    },

    { 
      id: 4,
      image: "/assets/images/face-cream-container.jpg",
      
      name: "Product 4",
      price: "$1,270.25",
      shipping: "Free",
      uptime: "15"
    },

    { 
      id: 5,
      image: "/assets/images/skincare-jar-with-rings.jpg",
      
      name: "Product 5",
      price: "$420.25",
      shipping: "Free",
      uptime: "15"
    },

    { 
      id: 6,
      image: "/assets/images/natural-skincare-products.png",
      
      name: "Product 6",
      price: "$350.25",
      shipping: "Free",
      uptime: "15"
    },

    { 
      id: 7,
      image: "/assets/images/amber-skincare-bottles.jpg",
      
      name: "Product 7",
      price: "$120.25",
      shipping: "Free",
      uptime: "15"
    },

  ]

  return (
    <div className='max-w-[1400px] mx-auto mt-3'>
      <div className="flex gap-3 mb-6 py-6 px-10">
        <input
          type="text"
          placeholder="Search for anything"
          value={""}
          className="flex-1 border border-gray-300 rounded-full px-5 py-2 text-sm outline-none"
        />
        <button className="bg-blue-600 text-white px-6 rounded-full text-sm">
          Search
        </button>
      </div>

      <div>
        <p className='text-3xl font-semibold'>
          My Supplier Dashboard
        </p>
        

        <div className='mb-3 border-b-2'>
          
          <button
            className="items-center rounded-xl bg-rose-600 px-6 py-1 text-white shadow hover:bg-rose-700 m-2"
          >
              Activities
          </button>

          <button
            className="items-center rounded-xl bg-white px-6 py-1 text-red-800 shadow hover:bg-rose-400 hover:text-white"
          >
              Messages
          </button>
          
        </div>

        <div className='grid grid-cols-6'>
          
          <div className='col-span-1'>
            <div className="flex w-full">

              {/* LEFT FILTERS */}
              <div className="hidden md:block">

                {/* <h3 className="text-lg font-semibold mb-3 flex items-center justify-between">
                  <span>Filters</span>
                </h3> */}

                <div className="space-y-2 ml-4 text-base text-gray-700">
                  <label className="flex items-center gap-2 font-semibold text-lg">
                    Summary
                  </label>

                  <label className="flex items-center gap-2">
                    Active
                  </label>

                  <label className="flex items-center gap-2">
                    Drafts
                  </label>

                  <label className="flex items-center gap-2">
                    Scheduled
                  </label>

                  <label className="flex items-center gap-2">
                    Orders
                  </label>

                  <label className="flex items-center gap-2">
                    Inactive
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className='col-span-5'>

            <div className='grid grid-cols-7 m-4 rounded-xl p-4 h-[150px] text-xl text-white content-center bg-rose-600'>
              
              <div className='col-span-1 flex flex-col text-xl justify-center text-center'>
                <div className='text-3xl'>
                  24
                </div>
                <div className='text-sm'>
                  Active
                </div>
              </div>

              <div className='col-span-1 flex flex-col text-xl justify-center text-center'>
                <div className='text-3xl'>
                  12
                </div>
                <div className='text-sm'>
                  Orders
                </div>
              </div>

              <div className='col-span-1 flex flex-col text-xl justify-center text-center'>
                <div className='text-3xl'>
                  1
                </div>
                <div className='text-sm'>
                  Canceled
                </div>
              </div>

              <div className='col-span-2 flex flex-col text-xl justify-center text-center'>
                <div className='text-4xl'>
                  $1234.56
                </div>
                <div className='text-sm'>
                  90-day total
                </div>
              </div>

              <div className='col-span-2 flex flex-col text-xl justify-center text-center'>
                
                <Link
                  to="/createNewListing"
                >
                  <button
                  className="rounded-xl bg-white py-1 text-red-800 text-base font-semibold shadow hover:bg-rose-400 hover:text-white px-4 mx-4"
                  >
                    Create New Product
                  </button>
                </Link>
                
                
              </div>

              

            </div>
            
            <div>

              <div className='text-2xl font-semibold'>
                Active
              </div>

              <div>

                {listings.map((listing) => (
                  <div className='grid grid-cols-6 p-3'>
                    
                    <div className='col-span-1 max-w-[200px] mx-2'>
                      <img
                        src={listing.image || "/placeholder.svg"}
                        alt={`Product ${listing.id}`}
                        className="max-h-full rounded-xl hover:scale-105 transition-transform duration-300"
                      />
                    </div>

                    <div className='col-span-3 mx-6 text-gray-500 text-xs'>
                      <div><p className='font-medium text-black text-lg'>{listing.name}</p></div>
                      <div><p className='text-xs'>Item ID: {listing.id}</p></div>
                      <div><p className='text-2xl font-semibold text-black'>{listing.price}</p></div>
                      <div><p>{listing.shipping}</p></div>
                      <div><p>Listed {listing.uptime} days ago</p></div>
                    </div>

                    <div className='col-span-2 content-center'>

                      <div>
                        <div className='flex flex-col justify-center p-2 gap-2 mx-4'>
                          <button
                            className="items-center rounded-xl bg-rose-600 px-6 py-1 text-white shadow hover:bg-rose-700"
                          >
                              Send offer
                          </button>

                          <button
                            className="items-center rounded-xl bg-white px-6 py-1 text-red-800 shadow hover:bg-rose-400 hover:text-white"
                          >
                              Edit
                          </button>
                        </div>
                        
                      </div>

                      <div className='grid grid-cols-2'>

                        <div className='flex flex-col text-xl justify-center text-center'>
                          <div>
                            74
                          </div>
                          <div className='text-sm'>
                            Views
                          </div>
                        </div>

                        <div className='flex flex-col text-xl justify-center text-center'>
                          <div>
                            10
                          </div>
                          <div className='text-sm'>
                            Fave'd
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                ))}

                
                
              </div>

              {/* <div className='bg-green-100'>
                Minimap
              </div> */}

              
            </div>

            {/* <div className='bg-red-400'>
              Drafts
            </div>

            <div className='bg-red-300'>
              Scheduled
            </div> */}
            
          </div>

        </div>


      </div>
    </div>
  )
}

export default SupplierDashboard